import { render } from "./ClusterRequest.vue?vue&type=template&id=15c9a67a&scoped=true"
import script from "./ClusterRequest.vue?vue&type=script&lang=js"
export * from "./ClusterRequest.vue?vue&type=script&lang=js"

import "./ClusterRequest.vue?vue&type=style&index=0&id=15c9a67a&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c9a67a"]])

export default __exports__